import axios from 'axios';

const api = axios.create({
  // En production, définir REACT_APP_API_URL au moment du build (ex. "/api"
  // si le frontend et l'API sont servis sous le même domaine via reverse proxy).
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3000/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('nexacom_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Efface la session et renvoie vers la connexion sur token expiré/invalide
// SAUF pour /auth/login pour afficher le message d'erreur normalement
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isLoginRequest = error.config?.url?.includes('/auth/login');
    if (error.response?.status === 401 && !isLoginRequest) {
      localStorage.removeItem('nexacom_token');
      localStorage.removeItem('nexacom_user');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default api;
